import React, { Component } from 'react';
import Button from '../../Button';
import apiInstance from '../../apiInstance';

class AddWidgetPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            widget: {
                id: props.data?.widget?.id || '',
                displayName: props.data?.widget?.displayName || '',
                name: props.data?.widget?.name || '',
                price: props.data?.widget?.price || '0',
                desc: props.data?.widget?.desc || '',
                category: props.data?.widget?.category || 'feeds',
                stripePriceId: props.data?.widget?.stripePriceId || '',
                stripeProductId: props.data?.widget?.stripeProductId || '',
                scripts: {
                    main: props.data?.widget?.scripts?.main || '',
                    lib: props.data?.widget?.scripts?.lib || ''
                },
                bannerImage: props.data?.widget?.bannerImage || '',  
                iconImage: props.data?.widget?.iconImage || '' 
            },
            bannerFile: null,
            iconFile: null,
            type: props?.type || 'add',
            fieldErrors: {},
        };
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;

        this.setState((prevState) => ({
            widget: {
                ...prevState.widget,
                [name]: value
            }
        }));
    }

    handleScriptChange = (e) => {
        const { name, value } = e.target;

        this.setState((prevState) => ({
            widget: {
                ...prevState.widget,
                scripts: {
                    ...prevState.widget.scripts,
                    [name]: value
                }
            }
        }));
    }

    handleImageChange = (e) => {
        const { name, value } = e.target;
    
        this.setState((prevState) => ({
            widget: {
                ...prevState.widget,
                [name]: value
            }
        }));
    };
    
    addWidget = () => {
        let {widget, type} = this.state;
        widget.name = widget.name.toLowerCase();
        if(type == 'update') {

            apiInstance.put(`/devadmin/availableWidget/${widget.id}`, widget)
            .then((response) => {
                this.props.updateAvailableWidget(response.data.availableWidget)
                this.props.closePopup();
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status == 400 && error.response.data.fieldErrors) {
                        this.setState((prevState) => {
                            return ({
                                ...prevState,
                                fieldErrors: error.response.data.fieldErrors
                            })
                        })
                    }
                    else {
                        this.props.updateError(error.response.data);
                    }
                }
            });

        } else {
            
            apiInstance.post(`/devadmin/availableWidget`, widget)
            .then((response) => {
                this.props.addAvailableWidget(response.data.availableWidget)
                this.props.closePopup();
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status == 400 && error.response.data.fieldErrors) {
                        this.setState((prevState) => {
                            return ({
                                ...prevState,
                                fieldErrors: error.response.data.fieldErrors
                            })
                        })
                    }
                    else {
                        this.props.updateError(error.response.data);
                    }
                }
            });
        }
    }

    handleBannerFileChange = (e) => {
        this.setState({ bannerFile: e.target.files[0] });
    };
    
    handleIconFileChange = (e) => {
        this.setState({ iconFile: e.target.files[0] });
    };
    
    uploadBannerImage = async () => {
        if (!this.state.bannerFile && this.state.widget.name) return alert("Please select a file! and Widgetname");
        
        const formData = new FormData();
        const fileExtension = this.state.bannerFile.name.split('.').pop();
        const customFileName = `${this.state.widget.name}-banner.${fileExtension}`;
        
        // Create a new File object with the custom name
        const renamedFile = new File(
            [this.state.bannerFile], 
            customFileName, 
            {type: this.state.bannerFile.type}
        );
        
        formData.append("file", renamedFile);
        formData.append("originalFileName", customFileName);
        console.log(formData);
    
        try {
            const response = await apiInstance.post("devadmin/upload", formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
    
            this.setState((prevState) => ({
                widget: { ...prevState.widget, bannerImage: response.data.filePath },
                bannerFile: null
            }));
        } catch (error) {
            console.error("Error uploading banner image:", error);
        }
    };
    uploadIconImage = async () => {
        if (!this.state.iconFile && this.state.widget.name) return alert("Please select a file! and Widgetname");
        
        const formData = new FormData();
        const fileExtension = this.state.iconFile.name.split('.').pop();
        const customFileName = `${this.state.widget.name}-icon.${fileExtension}`;
        
        // Create a new File object with the custom name
        const renamedFile = new File(
            [this.state.iconFile], 
            customFileName, 
            {type: this.state.iconFile.type}
        );
        
        formData.append("file", renamedFile);
        formData.append("originalFileName", customFileName);
        console.log(formData);
    
        try {
            const response = await apiInstance.post("devadmin/upload", formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
    
            this.setState((prevState) => ({
                widget: { ...prevState.widget, iconImage: response.data.filePath },
                iconFile: null
            }));
        } catch (error) {
            console.error("Error uploading icon image:", error);
        }
    };
    

    render() {
        const { type, fieldErrors } = this.state;
        const { displayName, name, price, desc, category, stripeProductId, stripePriceId, scripts } = this.state.widget;

        return (
                <div className='mjwidev-add-widget-pp mjwidev-pp'>
                    <h2>{type === 'add' ? 'Add New Product' : 'Edit Product'}</h2>
                    <form type='#' className='mjwi-row'>
                        <div className='mjwi-col50'>

                        <div className='mjwidev-input-field'>
                        <label>Product Name:</label>
                            <input
                                type="text"
                                placeholder="Name"
                                name="displayName"
                                value={displayName}
                                onChange={this.handleInputChange}
                            />
                             {fieldErrors.displayName && <span className="mjwi-error">{fieldErrors.displayName}</span>}
                        </div>

                        <div className='mjwidev-input-field'>
                        <label>Product ID (lowercase):</label>
                            <input
                                type="text"
                                placeholder="ID"
                                name="name"
                                value={name}
                                onChange={this.handleInputChange}
                            />
                             {fieldErrors.name && <span className="mjwi-error">{fieldErrors.name}</span>}
                        </div>

                        <div className='mjwidev-input-field'>
                            <label>Description:</label>
                            <input
                                placeholder="Widget description"
                                name="desc"
                                value={desc}
                                onChange={this.handleInputChange}
                            />
                        </div>

                        <div className='mjwidev-input-field'>
                            <label>Price:</label>
                            <input
                                type="number"
                                placeholder="Price"
                                name="price"
                                value={price}
                                onChange={this.handleInputChange}
                            />
                            {fieldErrors.price && <span className="mjwi-error">{fieldErrors.price}</span>}
                        </div>

                        <div className='mjwidev-input-field'>
                            <label>Category:</label>
                            <select
                                name="category"
                                value={category}
                                onChange={this.handleInputChange}
                            >
                                
                                <option value={"feeds"}>Feeds</option>
                                <option value={"files"}>Files</option>
                                <option value={"listings"}>Listings</option>
                                <option value={"reviews"}>Reviews</option>
                                <option value={"misc"}>Miscellaneous</option>
                            </select>
                            {fieldErrors.category && <span className="mjwi-error">{fieldErrors.category}</span>}
                        </div>

                        <div className='mjwidev-input-field'>
                            <label>Stripe Price Id:</label>
                            <input
                                type="text"
                                placeholder="Stripe Price Id"
                                name="stripePriceId"
                                value={stripePriceId}
                                onChange={this.handleInputChange}
                            />
                            {fieldErrors.stripePriceId && <span className="mjwi-error">{fieldErrors.stripePriceId}</span>}
                        </div>

                        <div className='mjwidev-input-field'>
                            <label>Stripe Product Id:</label>
                            <input
                                type="text"
                                placeholder="Stripe Product Id"
                                name="stripeProductId"
                                value={stripeProductId}
                                onChange={this.handleInputChange}
                            />
                            {fieldErrors.stripeProductId && <span className="mjwi-error">{fieldErrors.stripeProductId}</span>}
                        </div>

                        <div className='mjwidev-input-field'>
                            <label>Main Script:</label>
                            <input
                                type="text"
                                placeholder="Main script"
                                name="main"
                                value={scripts.main}
                                onChange={this.handleScriptChange}
                            />
                            {fieldErrors?.scripts?.main && <span className="mjwi-error">{fieldErrors.scripts.main}</span>}
                        </div>

                        <div className='mjwidev-input-field'>
                        <label>Library Script:</label>
                            <input
                                type="text"
                                placeholder="Lib script"
                                name="lib"
                                value={scripts.lib}
                                onChange={this.handleScriptChange}
                            />
                            {fieldErrors?.scripts?.lib && <span className="mjwi-error">{fieldErrors.scripts.lib}</span>}
                        </div>
                        </div>
                        <div className='mjwi-col50'>
                        <div className="mjwidev-input-field">
                            <label>Banner Image URL:</label>
                            <input
                              type="text"
                              placeholder="Enter Banner Image URL"
                              name="bannerImage"
                              value={this.state.widget.bannerImage}
                              onChange={this.handleImageChange}
                            />
                              <input
                                type="file"
                                accept="image/*"
                                onChange={this.handleBannerFileChange}
                            />
                            <button type="button" className='Save mjwi-btn' onClick={this.uploadBannerImage}>Upload</button>
                            <div className="mjwidev-new-banner-image">
                            {this.state.widget.bannerImage && (
                            <img
                              src={
                                this.state.widget.bannerImage.startsWith("devadmin")
                                  ? `${process.env.REACT_APP_SERVER_URL}/${this.state.widget.bannerImage}?ts=${Date.now()}`
                                  : `${this.state.widget.bannerImage}?ts=${Date.now()}`
                              }
                              alt="Banner"
                              width="100%"
                            />
                            )}
                            </div>
                        </div>
                          
                        <div className="mjwidev-input-field">
                            <label>Product Icon Image URL:</label>
                            <input
                              type="text"
                              placeholder="Enter Icon Image URL"
                              name="iconImage"
                              value={this.state.widget.iconImage}
                              onChange={this.handleImageChange}
                            />
                             <input
                                type="file"
                                accept="image/*"
                                onChange={this.handleIconFileChange}
                            />
                            <button type="button" className='Save mjwi-btn' onClick={this.uploadIconImage}>Upload</button>
                            <div className="mjwidev-new-icon-image">
                              {this.state.widget.iconImage && (
                                <img
                                  src={this.state.widget.iconImage.startsWith("devadmin")
                                    ? `${process.env.REACT_APP_SERVER_URL}/${this.state.widget.iconImage}?ts=${Date.now()}`
                                    : `${this.state.widget.iconImage}?ts=${Date.now()}`}
                                  alt="Icon"
                                  width="50px"
                                  height="50px"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                    </form>
                    <div class="mjwidev-bottom-row">
                        <Button name={type === 'add' ? 'Save' : 'Update'} eventHandler={this.addWidget} />
                        <Button name="Cancel" eventHandler={this.props.closePopup} />
                    </div>
                </div>
        );
    }
}

export default AddWidgetPopup;
